import Api from '@/api/api.js'

export default {
    // Liste des soins
    getSoins() {
        const promise = Api().get('/soins')
        return promise.then((response) => response.data)
    },

    /**
     * Save Conduite à tenir
     * @param {*} data 
     */
    saveCAT(data) {
        const promise = Api().post('/conduite_a_tenirs', data)
        return promise.then((response) => response.data)
    },

    /**
     * Save Constantes of CAT
     * @param {*} data 
     */
    saveCatConstante(data) {
        const promise = Api().post('/conduite_a_tenirs/constantes', data)
        return promise.then((response) => response.data)
    },

    /**
     * Recupère les conduites à tenir selon une consultation
     * @param {*} consultation_id 
     * @returns 
     */
    getCAT(consultation_id, date_cat) {
        if (date_cat == '') {
            const promise = Api().get('/conduite_a_tenirs/' + consultation_id)
            return promise.then((response) => response.data)
        } else {
            const promise = Api().get('/conduite_a_tenirs/0/' + date_cat)
            return promise.then((response) => response.data)
        }
    },
    getSoinsCPN(date_cat){
        const promise = Api().get('/conduite_a_tenirs/0/'+date_cat+'/CPN')
        return promise.then((response) => response.data)
    },

    // recupère les soins sans consultation
    getSoinsSansConsultation(date) {
        const promise = Api().get(`/soins/sans_consultation/${date}`)
        return promise.then(response => response.data)
    },
    // update un soin sans consultation
    updateSoinSansConsultation(medecin, soin) {
        const promise = Api().get(`/update_soins_sans_consult/${soin}/medecin/${medecin}`)
        return promise.then(response => response.data)
    },

    getListeDateProtocole(data) {
        const promise = Api().get('/consultations/'+data.consultation_id+'/dates/protocole')
        return promise.then(response => response.data)
    },

    getListeSoinsByDate(data) {
        const promise = Api().post('/consultations/protocole-par-date', data)
        return promise.then(response => response.data)
    },

    getSoinAdmission(data) {
        const promise = Api().post('/consultations/protocole/admission', data)
        return promise.then(response => response.data)
    },

    saveSoinsAdmission(data) {
        const promise = Api().post('/consultations/protocole/admission/store', data)
        return promise.then(response => response.data)
    },

    saveSoinsConsommable(data) {
        const promise = Api().post('/consultations/protocole/consommables/store', data)
        return promise.then(response => response.data)
    },

    startProtocole(data) {
        const promise = Api().post('/consultations/protocole/demarrer-soins', data)
        return promise.then(response => response.data)
    },

    endProtocole(data) {
        const promise = Api().post('/consultations/protocole/terminer-soins', data)
        return promise.then(response => response.data)
    },

    getEtatProtocoleSoins(data) {
        const promise = Api().post('/consultations/protocole/statut', data)
        return promise.then(response => response.data)
    },

    setEtatProtocole(data) {
        const promise = Api().post('/consultations/protocole/changer-etat', data)
        return promise.then(response => response.data)
    },

    saveSoinsProcess(data) {
        const promise = Api().post('/consultations/protocole/soin-en-cours/save', data)
        return promise.then(response => response.data)
    },

    getInfoSoinsEnCours(data) {
        const promise = Api().post('/consultations/protocole/soin-en-cours/list', data)
        return promise.then(response => response.data)
    },

    editDiagnosticHn(data) {
        const promise = Api().post('/consultations/protocole/edit-diagnostic', data)
        return promise.then(response => response.data)
    },

    deleteDiagnosticFromHn(data) {
        const promise = Api().post('/consultations/protocole/diagnostic/delete', data)
        return promise.then(response => response.data)
    },

    saveConstanteForHn(data) {
        const promise = Api().post('/consultations/protocole/constante/store', data)
        return promise.then(response => response.data)
    },

    saveOrganeForHn(data) {
        const promise = Api().post('/consultations/protocole/organes/store', data)
        return promise.then(response => response.data)
    },

    saveDemandeAnalyseForHn(data) {
        const promise = Api().post('/consultations/protocole/demande-analyse', data)
        return promise.then(response => response.data)
    },

    deleteDemandeAnalyseForHn(data) {
        const promise = Api().post('/consultations/protocole/demande-analyse/delete', data)
        return promise.then(response => response.data)
    },

    deleteDemandeExamenForHn(data) {
        const promise = Api().post('/consultations/protocole/demande-examen/delete', data)
        return promise.then(response => response.data)
    },

    deletePrescriptionForHn(data) {
        const promise = Api().post('/consultations/protocole/prescription/delete', data)
        return promise.then(response => response.data)
    },
}